<template>
  <topics-loader>
    <mc-app-header title="Edit Topic">
      <template v-slot:right>
        <div
          v-show="topics.selected.id === $route.params.id"
          class="level-item"
        >
          <b-button
            :loading="topics.submitting"
            type="is-primary"
            @click="updateTopicHandler"
            >Update</b-button
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="edit-topic section">
        <b-loading v-if="topics.loadingTopic" active :is-full-page="false" />
        <mc-error-layout
          v-else-if="topics.errorTopic"
          message="Failed to load topic!"
          :retry-fn="() => getTopic($route.params.id)"
        />
        <div v-else>
          <form
            class="edit-topic__form mc-container"
            @submit.prevent="updateTopicHandler"
          >
            <b-field label="Tag Topic">
              <b-taginput
                v-model="topics.selected.tags"
                allow-new
                autocomplete
                :data="tags"
                ellipsis
                icon="label"
                maxtags="1"
                placeholder="Type in tag to add, and press Enter"
                @typing="searchTagsHandler"
              >
                <template #default="{ option }">
                  {{ option }}
                </template>
              </b-taginput>
            </b-field>
            <b-field label="Name">
              <b-input
                v-model="topics.selected.name"
                icon="format-title"
                placeholder="Name"
                type="text"
              />
            </b-field>
            <b-field label="Poster">
              <mc-image-input
                v-model="topics.selected.poster"
                icon="image"
                placeholder="Poster Link"
                type="POSTER"
              />
            </b-field>
            <b-field label="Estimated # of Classes">
              <b-input
                v-model.number="topics.selected.classCount"
                icon="numeric"
                placeholder="Estimated # of classes"
                type="number"
              />
            </b-field>
          </form>
          <div class="edit-topic__concepts mc-container">
            <div class="edit-topic__concepts-header">
              <div class="title is-6">Related Concepts</div>
              <router-link
                v-if="isConceptCreator"
                class="button is-small is-primary is-outlined"
                :to="`/concepts/new?topic=${queryString}`"
                >Add New</router-link
              >
            </div>
            <mc-dnd-list
              v-if="topics.concepts.length > 0"
              :list="topics.concepts"
              :on-drop="moveConceptHandler"
              :sort-handler="sortHandler"
            >
              <template #item="{ item }">
                <concept-item :item="item" />
              </template>
            </mc-dnd-list>
            <div v-else class="box">
              <p class="content has-text-centered">
                There are no concepts related to this topic!
              </p>
            </div>
          </div>
        </div>
      </div>
    </mc-app-body>
  </topics-loader>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapActions, mapState } from 'vuex';
import sortBy from 'lodash/sortBy';

import ConceptItem from './ConceptItem';
import TopicsLoader from './TopicsLoader';

export default {
  data: function() {
    return {
      tags: []
    };
  },
  computed: {
    ...mapState(['topics', 'auth']),
    queryString() {
      return `${this.$route.params.id}_${this.topics.selected.name}`;
    }
  },
  methods: {
    ...mapActions('topics', ['getTopic', 'moveConcept', 'updateTopic']),
    async moveConceptHandler({ fromItem, toItem }) {
      const from = fromItem.serialNumber;
      const to = toItem.serialNumber;
      await this.moveConcept({
        topicId: this.$route.params.id,
        from,
        to
      });
    },
    searchTagsHandler: debounce(function(search) {
      const index = this.$searchClient.initIndex('topics');
      index.searchForFacetValues(
        {
          facetName: 'tags',
          facetQuery: search,
          hitsPerPage: 5
        },
        (error, data) => {
          if (error) {
            this.$buefy.toast.open({
              message: 'Failed to search for flow tags!',
              type: 'is-danger'
            });
          } else {
            this.tags = data.facetHits.map(o => o.value);
          }
        }
      );
    }, 400),
    sortHandler(list) {
      return sortBy(list, ['serialNumber']);
    },
    async updateTopicHandler() {
      try {
        await this.updateTopic({ ...this.topics.selected });
        this.$buefy.toast.open({
          message: 'Topic updated successfully!',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update topic!',
          type: 'is-danger'
        });
      }
    }
  },
  mounted() {
    this.getTopic(this.$route.params.id);
  },
  components: {
    ConceptItem,
    TopicsLoader
  }
};
</script>

<style lang="scss" scoped>
.edit-topic {
  &__form {
    margin-bottom: 2rem;
  }

  &__concepts-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    .title {
      margin-right: 0.5rem;
      margin-bottom: 0;
    }
  }
}
</style>
